import { z } from 'zod';

// The company behind London Life, shown in the legal documents and the site footer. Kept in the
// database so the super admin can update it from the dashboard (for example when the ICO registration
// number arrives) without a code change; every change is audited.
const email = z.string().trim().email().max(120);
export const CompanyDetails = z
  .object({
    companyName: z.string().trim().min(2).max(120),
    companyNumber: z
      .string()
      .trim()
      .regex(/^(\d{8}|[A-Z]{2}\d{6})$/, 'A Companies House number is 8 digits, or 2 letters and 6 digits'),
    registeredOffice: z.string().trim().min(5).max(200),
    // the data protection fee registration with the Information Commissioner's Office, once registered
    icoNumber: z
      .string()
      .trim()
      .regex(/^[A-Z0-9]{6,12}$/, 'An ICO registration number is 6 to 12 letters or digits')
      .nullable(),
    supportEmail: email,
    privacyEmail: email,
  })
  .strict();
export type CompanyDetails = z.infer<typeof CompanyDetails>;

// the starting values, from Companies House (company 16842787); the database copy wins once it exists
export const DEFAULT_COMPANY_DETAILS: CompanyDetails = {
  companyName: 'Whogocode ICT Resources Ltd',
  companyNumber: '16842787',
  registeredOffice: '5 Brayford Square, London E1 0SG',
  icoNumber: null,
  supportEmail: 'support@londonlifegame.com',
  privacyEmail: 'privacy@londonlifegame.com',
};
export const CompanyDetailsReply = z.object({ company: CompanyDetails });
